export default __webpack_public_path__ + "static/media/Android.412c5543.png";